export enum Table {
  Previews = "previews", // Deprecate in favor of Storage.Previews
  Websites = "websites",
  Templates = "templates",
  Users = "users",
  UsersCustomers = "users_customers",
  Subscriptions = "subscriptions",
  Components = "components",
}

export enum Function {
  BuildWebsite = "build-website",
  BuildPreview = "build-preview",
}

export enum Bucket {
  Previews = "previews",
  EdgeFunctionFs = "edge_functions_fs",
  Media = "media",
}

export enum PreviewType {
  Websites = "websites",
  Templates = "templates",
}

export enum WebsitesPageLayout {
  Grid = "grid",
  List = "list",
}

export const IS_SERVER_DEVELOPMENT = process.env.NODE_ENV === "development";

export const IS_DEVELOPMENT =
  process.env.REACT_APP_VERCEL_ENV === "development" ||
  process.env.REACT_APP_ENVIRONMENT === "development" ||
  process.env.NODE_ENV === "development";

export const CLIENT_URL =
  IS_SERVER_DEVELOPMENT || IS_DEVELOPMENT
    ? "http://localhost:3000"
    : "https://simplelanding.app";

export function removeHttp(url: string): string {
  return url
    .replace(/^https?:\/\//, "") // remove http(?s)://
    .split(":")[0]; // remove port
}

export const DOMAIN_URL = IS_DEVELOPMENT
  ? "simplelanding.app"
  : removeHttp(CLIENT_URL);

export const SERVER_URL = `${CLIENT_URL}/api`;

export enum AuthorizationHeaderKey {
  AccessToken = `X-SimpleLanding-Access`,
  RefreshToken = "X-SimpleLanding-Refresh",
}

export const DEMO_SUBDOMAIN_PREFIX = "demo";
